import { Builder } from '@builder.io/react'

import { ContentSwitcher } from './ContentSwitcher'
import { ContentSwitcherDefaults } from './ContentSwitcher.defaults'

export const contentSwitcherItemsInput = {
  name: 'items',
  friendlyName: 'Items',
  type: 'list',
  subFields: [
    {
      name: 'title',
      friendlyName: 'Title',
      type: 'text',
      helperText: 'Option name in the dropdown. Must be unique!',
    },
    {
      name: 'contentTop',
      friendlyName: 'Content Top',
      type: 'list',
      hideFromUI: true,
      subFields: [
        {
          name: 'blocks',
          friendlyName: 'Blocks',
          type: 'uiBlocks',
        },
      ],
    },
    {
      name: 'contentBottom',
      friendlyName: 'Content Bottom',
      type: 'list',
      hideFromUI: true,
      subFields: [
        {
          name: 'blocks',
          friendlyName: 'Blocks',
          type: 'uiBlocks',
        },
      ],
    },
  ],
  defaultValue: ContentSwitcherDefaults.items,
}

Builder.registerComponent(ContentSwitcher, {
  name: 'ContentSwitcher',
  friendlyName: 'ContentSwitcher',
  inputs: [
    {
      name: 'previewMode',
      type: 'boolean',
      defaultValue: true,
    },
    { ...contentSwitcherItemsInput },
  ],
})
